<gtd-widgets-info-layout [isLoading]="isLoading" (onRefresh)="getData()">
  <p500-ui-cube-preloader *ngIf="isLoading"></p500-ui-cube-preloader>
  <div class="c-widget--info c-widget--info--white" *ngIf="!isLoading" [ngClass]="customClass">
    <ul>
      <li class="title" i18n="@@common.basic_information">Basic Information</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.name">Name</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.name"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.formula">Formula</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.formula"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.hint">Hint</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-whitespace-or-empty [data]="data.hint"></gtd-ui-field-default-string-whitespace-or-empty>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.short_name">Short Name</span>: </span>
          <span class="value">
            <gtd-ui-field-default-string-or-empty [data]="data.short_name"></gtd-ui-field-default-string-or-empty>
          </span>
        </p>
      </li>
    </ul>
    <ul>
      <li class="title" i18n="@@common.timestamps">Timestamps</li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.created_at">Created At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.created_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
      <li>
        <p>
          <span class="key"> <span i18n="@@common.updated_at">Updated At</span>: </span>
          <span class="value">
            <gtd-ui-field-default-datetime [data]="data.updated_at * 1000"></gtd-ui-field-default-datetime>
          </span>
        </p>
      </li>
    </ul>
  </div>
</gtd-widgets-info-layout>
